import { s as t, _ as c } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as a, c as m } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var i = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  c({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F6E4BE",
      d: "M10.865 22.267c-.763-.148-1.805-.255-2.648-.425a3.123 3.123 0 0 1 .168-1.789.58.58 0 0 0 .07-.122c-.7-.001-1.484.36-1.834.854-.09.126-.15.265-.115.403.037.146.28.583.481 1.124.14.38.257.798.277 1.163.012.204.242.324.641.45.319.101.814.098 1.147.109.02.33-.015.677-.136 1.154a.562.562 0 0 0 .076.424c.112.174.315.29.492.405 2.066 1.35 4.388 2.042 6.505 2.042 2.116 0 4.438-.693 6.504-2.042.177-.116.38-.23.492-.405a.563.563 0 0 0 .076-.424c-.122-.477-.157-.825-.136-1.154.332-.01.828-.008 1.147-.109.398-.126.63-.246.64-.45.02-.365.137-.783.278-1.163.2-.541.443-.978.481-1.124.035-.138-.026-.277-.115-.403-.35-.495-1.134-.855-1.833-.854l.03.12c.303.672.306 1.25.207 1.79-.844.171-1.887.278-2.65.426-.383.057-.695.224-.806.456a.353.353 0 0 0 .013.291c.262.497.763.845.727 1.583-.114.068-.228.134-.344.198-1.68.931-2.966 1.228-4.711 1.228-1.746 0-3.031-.297-4.712-1.228a11.71 11.71 0 0 1-.344-.198c-.036-.738.465-1.086.749-1.592a.44.44 0 0 0-.01-.282c-.11-.232-.423-.4-.807-.456Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M8.897 6.4S12.332 5.334 16 5.334c3.667 0 7.286 1.06 7.286 1.06l-1.996 3.821c-3.351-.981-7.328-.985-10.563 0l-1.83-3.813Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2C97DE",
      d: "M10.727 10.214a184.594 184.594 0 0 0 0 5.484c.025 1.76.11 3.135.871 4.21.917 1.294 2.445 2.228 4.41 3.146 1.966-.918 3.494-1.852 4.41-3.146.762-1.075.847-2.45.872-4.21.027-1.828.028-3.656 0-5.484H10.727Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M21.307 14c-.003.566-.009 1.132-.017 1.698-.012.855-.039 1.62-.15 2.302H10.876c-.11-.683-.137-1.447-.15-2.302-.008-.566-.013-1.132-.017-1.698h10.598Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      d: "m14.666 16.608 1.283-.532-.522 1.306.57-.387.57.387-.523-1.306 1.283.532-.38-.58.38-.581-1.283.532.523-1.306-.57.387-.57-.387.522 1.306-1.283-.532.38.58-.38.581Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#EACE24",
      d: "M24.48 20.134c.015 1.583.028 1.639.028 1.639-.68.68-.761.928-.963 1.149-.261-.386-.667-.232-.667-.232-.082-.364-.516-.679-.516-.679.605-.049 1.651-.364 1.734-.49.274-.42-.104-1.689-.104-1.689l.489.302Zm-.496-.751s-.841-.35-1.703.266a.41.41 0 0 1-.208.006c-.167-.182-.545-.717-.837-.648-.021-.452.03-2.259.03-2.259.126-.005.17.248.17.248-.073.515.219 3.646 1.415 1.575l.847.09.286.722Zm.46-7.243c-.722.267-.731.408-1.446 1.052-.571.231-1.422.798-1.47.924l.047.185c-.11.07-.215-.189-.215-.189.11-.637 2.121-2.557 2.121-2.557l.885.19.078.396Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M23.144 9.837c1.106-.233 2.018.225 2.738 1.377.08.128.15.259.21.392.528-.674.919-.986 1-.907.216.207 1.754 1.845 1.187 4.487-.074.346-.702.283-1.388.72-.153.098 1.1.893.27 1.582-.829.69-.952-.848-1.058-.48-.045.158-.11.446-.198.864 1.355.975 1.868 1.761 1.537 2.357-.33.596-1.153.26-2.468-1.009-.277.362-.413 1.177-.413 1.177-.293.077-.449.07-.467-.02.039-1.393-2.64-2.532-2.587-4.092-.068-1.615 1.637-2.228 2.683-3.587 0 0 .294-.891-.248-.497-.437-.07-.399-.511-.399-.511h-.24c-.08-.702.411-.765.674-.75-.187-.355-.464-.723-.833-1.103Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#EACE24",
      d: "M7.597 20.134c-.014 1.583-.028 1.639-.028 1.639.681.68.762.928.963 1.149.262-.386.668-.232.668-.232.082-.364.516-.679.516-.679-.606-.049-1.651-.364-1.734-.49-.274-.42.103-1.689.103-1.689l-.488.302Zm.497-.751s.84-.35 1.703.266a.41.41 0 0 0 .208.006c.166-.182.544-.717.836-.648.022-.452-.029-2.259-.029-2.259-.126-.005-.17.248-.17.248.073.515-.22 3.646-1.416 1.575l-.846.09-.286.722Zm-.461-7.243c.723.267.732.408 1.447 1.052.57.231 1.421.798 1.47.924l-.047.185c.11.07.214-.189.214-.189-.11-.637-2.12-2.557-2.12-2.557l-.886.19-.078.396Z"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M8.933 9.837c-1.105-.233-2.017.225-2.737 1.377-.08.128-.15.259-.21.392-.528-.674-.92-.986-1.001-.907-.216.207-1.753 1.845-1.187 4.487.075.346.703.283 1.388.72.154.098-1.1.893-.27 1.582.83.69.953-.848 1.058-.48.045.158.111.446.199.864-1.356.975-1.868 1.761-1.537 2.357.33.596 1.153.26 2.467-1.009.278.362.413 1.177.413 1.177.294.077.45.07.468-.02-.039-1.393 2.64-2.532 2.586-4.092.069-1.615-1.637-2.228-2.682-3.587 0 0-.058-.175-.075-.335a6.803 6.803 0 0 1-.004-.117c.01-.142.086-.22.326-.045.438-.07.4-.511.4-.511h.24c.079-.702-.412-.765-.674-.75.187-.355.464-.723.832-1.103Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M13 13.333c.552 0 1-.597 1-1.333s-.448-1.333-1-1.333-1 .597-1 1.333.448 1.333 1 1.333Zm6 0c.552 0 1-.597 1-1.333s-.448-1.333-1-1.333-1 .597-1 1.333.448 1.333 1 1.333Zm-3 0c.552 0 1-.597 1-1.333s-.448-1.333-1-1.333-1 .597-1 1.333.448 1.333 1 1.333Zm-3.334 5.6 1-.266 1 .266L14.333 20H13l-.334-1.067Zm4.667 0 1-.266 1 .266L19 20h-1.334l-.333-1.067Zm-2.333 2 1-.266 1 .266L16.667 22h-1.334L15 20.933Z",
      clipRule: "evenodd"
    }
  )
), r = a(i)`
  ${t}
  ${m}
`, M = r;
export {
  M as default
};
